import {
    refreshCalendar, requestEndpoint
} from './network-switching';

const switchSimTypeNotices = ({
    publicId, simTypeChoice
}) => {
    const simTypeNotices = document.querySelectorAll(`.basket-item[data-public-id=${publicId}] .sim-type-notice`);
    simTypeNotices.forEach((notice) => {
        notice.classList.add('hidden');
    });
    let targetNotice;
    switch (simTypeChoice) {
        case 'PSIM':
            targetNotice = document.querySelector(`.basket-item[data-public-id=${publicId}] .psim-notice`);
            break;
        case 'ESIM':
            targetNotice = document.querySelector(`.basket-item[data-public-id=${publicId}] .esim-notice`);
            break;
        default:
            break;
    }
    targetNotice && targetNotice.classList.remove('hidden');

    const yourSimCardNode = document.querySelector('.your-sim-card');
    const hasPhysicalSim = Array.from(document.querySelectorAll('[data-esim-selection] input[type="radio"]:checked')).some(el => el.value === 'PSIM');
    if (hasPhysicalSim && yourSimCardNode) {
        yourSimCardNode.classList.remove('hidden');
    } else if (yourSimCardNode) {
        yourSimCardNode.classList.add('hidden');
    }
};

const populateSimTypeOnConfirmation = () => {
    document.querySelectorAll('.basket-item').forEach((item) => {
        const basketId = item.dataset.publicId;
        if (!basketId) {
            return;
        }

        const storedChoice = localStorage.getItem(
            `simChoice_${basketId}`
        );

        const targetSpan = document.getElementById(
            `card_sim_item_${basketId}`
        );

        if (!storedChoice || !targetSpan) {
            return;
        }

        if (storedChoice === 'ESIM') {
            targetSpan.innerText = 'eSIM';
        } else {
            targetSpan.innerText = 'SIM Card';
        }
    });
};

const changeLoaderTasksCount = (loader, amount) => {
    loader.dataset.activeTasks = parseInt(loader.dataset.activeTasks) + amount;
};
const saveSimTypeChoice = (publicId, simTypeChoice) => {
    const data = new URLSearchParams({
        publicId: publicId,
        simTypeChoice: simTypeChoice,
    });

    const loader = document.querySelector('[data-loading-overlay]');
    changeLoaderTasksCount(loader, 1);
    requestEndpoint('/beta/basket/sim-type-choice', 'POST', data)
        .then((response) => {
            if (response.hasNetworkSwitching) {
                const networkSwitchingForm = document.querySelector('.basket-item[data-public-id="' + publicId + '"] [data-network-switching]');
                if (!networkSwitchingForm) {
                    return;
                }

                refreshCalendar(networkSwitchingForm, publicId).then(() => {
                    networkSwitchingForm.querySelector('[data-network-switching-success]').classList.add('hidden');
                    networkSwitchingForm.querySelector('[data-network-switching-fieldset]').removeAttribute('disabled');
                    networkSwitchingForm.querySelector('[data-network-switching-available-dates]').parentElement.classList.remove('hidden');
                    networkSwitchingForm.querySelector('[data-date-choices]').value = '';
                    const chosenSimType = networkSwitchingForm.closest('.basket-item').querySelector('[data-esim-selection] input[type="radio"]:checked');
                    if (chosenSimType) {
                        networkSwitchingForm.querySelector('[data-network-switching-esim]').classList.toggle('hidden', chosenSimType.value === 'PSIM');
                    }
                });
            }
        })
        .finally(() => changeLoaderTasksCount(loader, -1));
};

const esim = () => {
    const hasEsimSelection = document.querySelector('[data-esim-selection]');
    if (hasEsimSelection) {
        const basketItems = document.querySelectorAll('.basket-item:has(.sim-type-selection-wrapper)');
        basketItems.forEach((basketItem) => {
            const publicId = basketItem.dataset.publicId;
            const inputEl = basketItem.querySelector('[data-esim-selection] input[type="radio"]:checked');
            if (!inputEl) {
                return;
            }
            const simTypeChoice = inputEl.value;
            localStorage.setItem(`simChoice_${publicId}`, simTypeChoice);
            switchSimTypeNotices({
                publicId,
                simTypeChoice,
            });
        });
        document.querySelectorAll('[data-esim-selection] input[type="radio"]').forEach((radioButton) => {
            radioButton.addEventListener('change', function() {
                if (radioButton.checked) {
                    const publicId = radioButton.closest('.basket-item').dataset.publicId;
                    const simTypeChoice = this.value;
                    localStorage.setItem(`simChoice_${publicId}`, simTypeChoice);
                    switchSimTypeNotices({
                        publicId,
                        simTypeChoice,
                    });
                    saveSimTypeChoice(publicId, simTypeChoice);
                }
            });
        });
    } else {
        populateSimTypeOnConfirmation();
    }
};

export default esim;
